export function convertSecondsToMinutes(inputTimeInSeconds: number): number {
  return inputTimeInSeconds / 60;
}
